import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import styles from './GetHelpZendeskEmptyState.scss';
import dibsCss from 'dibs-css';

const GetHelpZendeskEmptyState: FC<{ title: ReactNode; subtitle: ReactNode }> = ({
    title,
    subtitle,
}) => {
    return (
        <div
            className={classnames(
                styles.container,
                dibsCss.h450px,
                dibsCss.flex,
                dibsCss.flexCol,
                dibsCss.justifyCenter,
                dibsCss.textCenter,
                dibsCss.pxLarger
            )}
        >
            <h2 className={classnames(dibsCss.sassyFontHeaderLarge, dibsCss.mbXsmall)}>{title}</h2>
            <div className={dibsCss.sassyFontBodyMedium}>{subtitle}</div>
        </div>
    );
};

export { GetHelpZendeskEmptyState };
